import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-geia-button',
  templateUrl: './geia-button.component.html',
  styleUrls: ['./geia-button.component.scss'],
})
export class GeiaButtonComponent {
  @Input() type:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'success'
    | 'info'
    | 'geia-blue'
    | 'warning' = 'primary';
  @Input() disabled: boolean = false;
  @Input() icon?: string;
  @Input() label: string = 'Button';
  @Input() extraClass: string = ''; // Permite adicionar classes extras

  @Output() onClick = new EventEmitter<void>();

  handleClick() {
    if (!this.disabled) {
      this.onClick.emit();
    }
  }

  getButtonClasses() {
    return {
      'btn-primary': this.type === 'primary',
      'btn-secondary': this.type === 'secondary',
      'btn-danger': this.type === 'danger',
      'btn-success': this.type === 'success',
      'btn-info': this.type === 'info',
      'btn-warning': this.type === 'warning',
      'btn-geia-blue': this.type === 'geia-blue',
      [this.extraClass]: !!this.extraClass,
    };
  }
}
